





















import { Component, Vue } from 'vue-property-decorator';
import CreditCardForm from '../../components/CreditCardForm.vue';
import { AddPaymentSourceRequest, ApiRequest } from '../../types/request';
import { ObjectFactory } from '../../config/objectFactory';
import { MedTransGoConstants } from '../../util/constants';
import { CommonUtils } from '../../util/commonUtils';
import { EventBus } from '../../main';
import { ToastEvent } from '../../types/event';
@Component({
   components: {
      CreditCardForm,
   },
   props: {
        show: Boolean,
        customerId: String,
        billingLocations: {
            type: Array,
            required: false,
        },
   },
})
export default class AddCreditCardModal extends Vue {

    private paymentSource: string = '';
    private selectedLocationIds: string[] = [];
    private isLocationSelected = false;

    get isSaveDisabled() {
        if (!this.paymentSource) {
            return true;
        }
        if (this.$props.billingLocations && this.$props.billingLocations.length > 0) {
            return this.selectedLocationIds.length === 0;
        }
        return false;
    }


    private saveCreditCard(paymentSource: any) {
        if (paymentSource && paymentSource.cardToken
                && paymentSource.cardToken.token && paymentSource.cardHolderName) {
            this.paymentSource = paymentSource.cardToken.token.id;
            this.selectedLocationIds = paymentSource.selectedLocations || [];
        } else {
            this.paymentSource = '';
            this.selectedLocationIds = paymentSource.selectedLocations || [];
        }
    }

    private async addCustomerCreditCard() {
        const addPaymentSourceRequest: AddPaymentSourceRequest = {
            customerId: this.$props.customerId,
            paymentSource: this.paymentSource,
            billingLocationIds: this.selectedLocationIds,
        };
        const response = await ObjectFactory.getPaymentSourceService().
        addCustomerCreditCard(addPaymentSourceRequest, this.$store.state.serverUrl);
        if (response.success) {
            this.$emit('close');
            this.$emit('success');
        } else {
            CommonUtils.showError(response);
        }
    }

    private close() {
        this.$emit('close');
    }

}

